import * as React from 'react';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface Props {
    approved?: boolean | null;
}

/** Green tick shown next to a user's name only when their selfie (auth media) has been approved. */
export const ApprovedSelfieTick: React.FC<Props> = ({ approved }) =>
    approved ? (
        <Tooltip title="مدرک تایید شده">
            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ marginInlineStart: 6 }} />
        </Tooltip>
    ) : null;
